import type { LocationQuery, Router } from "vue-router";
import { PageEnum } from "/@/enums/pageEnum";
import { useUserStoreWithOut } from "/@/store/modules/user";

const LOGIN_PATH = PageEnum.BASE_LOGIN;

function navRedirect(query: LocationQuery | undefined, token: string) {
  if (query?.origin) {
    location.href = `${query.origin}#/?redirect=${encodeURIComponent(query.redirect as string)}&token=${encodeURIComponent(token)}`;
    return "/404";
  } else {
    return (query?.redirect as string) || PageEnum.HOME_PAGE;
  }
}

export function createPermissionGuard(router: Router) {
  const userStore = useUserStoreWithOut();
  router.beforeEach(async (to) => {
    if (to.path === "/") {
      return userStore.getHomePage;
    }

    if (to.meta?.ignoreAuth) {
      if (to.query.logout) {
        await userStore.logout(false, true);
        return {
          path: PageEnum.BASE_LOGIN,
          query: {
            ...to.query,
            logout: "",
          },
        };
      } else if (to.path === LOGIN_PATH && userStore.getUserInfo) {
        return navRedirect(to.query, userStore.getToken);
      } else if (to.name != "PageNotFound") {
        return;
      }
    }

    const token = userStore.getToken;
    if (token && !userStore.getUserInfo) {
      await userStore.afterLoginAction();
      if (userStore.getUserInfo) {
        return to.fullPath;
      } else {
        await userStore.logout(false, true);
        return PageEnum.BASE_LOGIN;
      }
    }

    if (token && !userStore.getUserInfo) {
      return navRedirect(to.query, token);
    }

    if (!token) {
      const redirectData: {
        path: string;
        replace: boolean;
        query?: Record<string, string>;
      } = {
        path: LOGIN_PATH,
        replace: true,
      };
      if (to.path) {
        redirectData.query = {
          ...redirectData.query,
          redirect: to.fullPath,
        };
      }
      return redirectData;
    }
  });
}
